module.exports = __webpack_public_path__ + "media/images/symbols/black-caret-left-465bd8cda36a4b236d72ef5ffe31b0be.svg";